export default __webpack_public_path__ + "static/media/jitsi.9991bf69.svg";